export interface Channel {
  title: string;
  code: string;
  path: string;
  type: string;
  permission: string;
}

export interface Channels {
  [key: string]: Channel;
}

const channels: Channels = {
  'credit-card': {
    title: 'Credit Card',
    code: 'credit_card',
    path: 'creditcard',
    type: 'credit-card',
    permission: 'PGPCS.ReportTransaction.CreditCard.View',
  },
  'bca-va': {
    title: 'BCA Virtual Account',
    code: 'bca_va',
    path: 'bca-va',
    type: 'online-transfer',
    permission: 'PGPCS.ReportTransaction.BCAVA.Report.View',
  },
  'bca-va-sftp': {
    title: 'BCA Virtual Account',
    code: 'bca_va_sftp',
    path: 'bca-va-sftp',
    type: 'online-transfer',
    permission: 'PGPCS.ReportTransaction.BCAVA.Report.View',
  },
  'bni-va': {
    title: 'BNI Virtual Account',
    code: 'bni_va',
    path: 'bni-va',
    type: 'online-transfer',
    permission: 'PGPCS.ReportTransaction.BNIVA.Report.View',
  },
  'bri-va': {
    title: 'BRI Virtual Account',
    code: 'bri_va',
    path: 'bri-va',
    type: 'online-transfer',
    permission: 'PGPCS.ReportTransaction.BRIVA.Report.View',
  },
  'danamon-va': {
    title: 'Danamon Virtual Account',
    code: 'danamon_va',
    path: 'danamon-va',
    type: 'online-transfer',
    permission: 'PGPCS.ReportTransaction.DanamonVA.Report.View',
  },
  'mandiri-va': {
    title: 'Mandiri Bill Payment',
    code: 'mandiri_va',
    path: 'mandiri-va',
    type: 'online-transfer',
    permission: 'PGPCS.ReportTransaction.MandiriVA.Report.View',
  },
  'maybank-va': {
    title: 'Maybank Virtual Account',
    code: 'maybank_va',
    path: 'maybank-va',
    type: 'online-transfer',
    permission: 'PGPCS.ReportTransaction.MaybankVA.Report.View',
  },
  'permata-va': {
    title: 'Permata Virtual Account',
    code: 'permata_va',
    path: 'permata-va',
    type: 'online-transfer',
    permission: 'PGPCS.ReportTransaction.PermataVA.Report.View',
  },
  bsi: {
    title: 'BSI',
    code: 'bni_syariahva',
    path: 'bsi',
    type: 'online-transfer',
    permission: 'PGPCS.ReportTransaction.BSI.Report.View',
  },
  arthagraha: {
    title: 'Arthagraha',
    code: 'bagi_va',
    path: 'arthagraha',
    type: 'online-transfer',
    permission: 'PGPCS.ReportTransaction.ArtagrahaVA.Report.View',
  },
  'klik-bca': {
    title: 'Klik BCA',
    code: 'klik_bca',
    path: 'klik-bca',
    type: 'instant-payment',
    permission: 'PGPCS.ReportTransaction.KlikBCA.Report.View',
  },
  'bca-sakuku': {
    title: 'BCA Sakuku',
    code: 'bca_sakuku',
    path: 'bca-sakuku',
    type: 'other',
    permission: 'PGPCS.ReportTransaction.BCASakuku.Report.View',
  },
  'bni-ipay': {
    title: 'BNI iPay',
    code: 'bni_ipay',
    path: 'bni-ipay',
    type: 'instant-payment',
    permission: 'PGPCS.ReportTransaction.BNIiPay.Report.View',
  },
  'bri-epay': {
    title: 'BRI ePay',
    code: 'bri_epay',
    path: 'bri-epay',
    type: 'instant-payment',
    permission: 'PGPCS.ReportTransaction.BRIePay.Report.View',
  },
  'cimb-click': {
    title: 'OCTO Click',
    code: 'cimb_click',
    path: 'cimb-click',
    type: 'instant-payment',
    permission: 'PGPCS.ReportTransaction.CIMBClick.Report.View',
  },
  'bca-klikpay': {
    title: 'BCA KlikPay',
    code: 'bca_klikpay',
    path: 'bca-klikpay',
    type: 'instant-payment',
    permission: 'PGPCS.ReportTransaction.BCAKlikPay.Report.View',
  },
  'permata-net': {
    title: 'Permata Net',
    code: 'permata_net',
    path: 'permata-net',
    type: 'instant-payment',
    permission: 'PGPCS.ReportTransaction.PermataNet.Report.View',
  },
  indodana: {
    title: 'Indodana',
    code: 'indodana',
    path: 'indodana',
    type: 'other',
    permission: 'PGPCS.ReportTransaction.Indodana.Report.View',
  },
  kredivo: {
    title: 'Kredivo',
    code: 'kredivo',
    path: 'kredivo',
    type: 'other',
    permission: 'PGPCS.ReportTransaction.Kredivo.Report.View',
  },
  tcash: {
    title: 'LinkAjaTCash',
    code: 'tcash',
    path: 'tcash',
    type: 'other',
    permission: 'PGPCS.ReportTransaction.LinkAja.Report.View',
  },
  'mandiri-ecash': {
    title: 'LinkAjaMeCash',
    code: 'mandiri_ecash',
    path: 'mandiri-ecash',
    type: 'other',
    permission: 'PGPCS.ReportTransaction.LinkAja.Report.View',
  },
  homecredit: {
    title: 'Home Credit',
    code: 'homecredit',
    path: 'homecredit',
    type: 'other',
    permission: 'PGPCS.ReportTransaction.HomeCredit.Report.View',
  },
  dana: {
    title: 'DANA',
    code: 'dana',
    path: 'dana',
    type: 'other',
    permission: 'PGPCS.ReportTransaction.DANA.Report.View',
  },
  shopeepay: {
    title: 'ShopeePay',
    code: 'shopeepay',
    path: 'shopeepay',
    type: 'other',
    permission: 'PGPCS.ReportTransaction.ShopeePay.Report.View',
  },
  easyinvoice: {
    title: 'Easy Invoice',
    code: 'easyinvoice',
    path: 'easyinvoice',
    type: 'other',
    permission: 'PGPCS.ReportTransaction.EasyInvoice.Report.View',
  },
  bayarind: {
    title: 'Bayarind',
    code: 'bayarind',
    path: 'bayarind',
    type: 'other',
    permission: 'PGPCS.ReportTransaction.Bayarind.Report.View',
  },
  alfamart: {
    title: 'Alfamart',
    code: 'alfamart',
    path: 'alfamart',
    type: 'other',
    permission: 'PGPCS.ReportTransaction.Alfamart.Report.View',
  },
  ovo: {
    title: 'OVO',
    code: 'ovo',
    path: 'ovo',
    type: 'other',
    permission: 'PGPCS.ReportTransaction.OVO.Report.View',
  },
  qris: {
    title: 'QRIS',
    code: 'qris',
    path: 'qris',
    type: 'other',
    permission: 'PGPCS.ReportTransaction.QRIS.Report.View',
  },
  atome: {
    title: 'Atome',
    code: 'atome',
    path: 'atome',
    type: 'other',
    permission: 'PGPCS.ReportTransaction.Atome.Report.View',
  },
  'bnc-va': {
    title: 'BNC Virtual Account',
    code: 'bnc_va',
    path: 'bnc-va',
    type: 'other',
    permission: 'PGPCS.ReportTransaction.BNCVA.Report.View',
  },
  aeon: {
    title: 'AEON',
    code: 'aeon',
    path: 'aeon',
    type: 'other',
    permission: 'PGPCS.ReportTransaction.AEON.Report.View',
  },
  'blu-bca': {
    title: 'Blu BCA',
    code: 'blubca',
    path: 'blu-bca',
    type: 'other',
    permission: 'PGPCS.ReportTransaction.BluBca.Report.View',
  },
  'btn-va': {
    title: 'BTN Virtual Account',
    code: 'btn_va',
    path: 'btn-va',
    type: 'online-transfer',
    permission: 'PGPCS.ReportTransaction.BTNVA.Report.View',
  },
};

export default channels;
